module.exports = __webpack_public_path__ + "img/appleStoreBg.422b0d1c.png";